import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const BandageIcon = createIcon({
  displayName: 'BandageIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M4.449 19.608v0c-1.797-1.797-1.797-4.71 0-6.506l8.652-8.652c1.797-1.797 4.71-1.797 6.506 0v0c1.797 1.797 1.797 4.71 0 6.506l-8.652 8.652c-1.797 1.796-4.71 1.796-6.506 0Z"></path>
        <line x1="10.5" x2="13.5" y1="10.5" y2="13.5"></line>
        <path d="M17.299 6.707c-.028 0-.05.022-.05.05 0 .028.022.05.05.05 .028 0 .05-.022.05-.05 0-.028-.022-.05-.05-.05"></path>
        <path d="M14.506 6.671c-.028 0-.05.022-.05.05 0 .028.022.05.05.05 .028 0 .05-.022.05-.05 0-.028-.022-.05-.05-.05"></path>
        <path d="M17.335 9.5c-.028 0-.05.022-.05.05 0 .028.022.05.05.05 .028 0 .05-.022.05-.05 0-.028-.023-.05-.05-.05"></path>
        <path d="M9.55 17.285c-.028 0-.05.022-.05.05 0 .028.022.05.05.05 .028 0 .05-.022.05-.05 0-.028-.022-.05-.05-.05"></path>
        <path d="M6.757 17.249c-.028 0-.05.022-.05.05 0 .028.022.05.05.05 .028 0 .05-.022.05-.05 0-.028-.022-.05-.05-.05"></path>
        <path d="M6.721 14.456c-.028 0-.05.022-.05.05 0 .028.022.05.05.05 .028 0 .05-.022.05-.05 0-.028-.022-.05-.05-.05"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const Bandage: FC<IconProps> = (props) => {
  return <CustomIcon as={BandageIcon} {...props} />
}

export default memo(Bandage)
